import { Model } from "pinia-orm";

export default class Answer extends Model {
  static entity = "answers";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      value: this.boolean(),
      extraData: this.attr(null),
      question: this.attr(null),
      lastModifiedByEmail: this.string(),
      objectRelatedId: this.attr(null),
    };
  }
}
